var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Base',{style:([_vm.styles])},[_c('div',{staticClass:"wrapper",domProps:{"innerHTML":_vm._s(_vm.data.embed.link)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }